<template>
  <PopupBanner
    v-if="currentPopupIndex < availablePopups.length"
    :key="currentPopup?.id"
    :popup="currentPopup"
    @close="nextPopup"
  />
</template>

<script>
import api from '@/api';
import PopupBanner from '@/components/PopupBanner.vue';
export default {
  props: {
    platform: {
      type: Number,
      default: 0,
    },
  },
  components: {
    PopupBanner,
  },
  data() {
    return {
      loading: false,
      popups: [],
      currentPopupIndex: 0,
      today: new Date().toLocaleDateString('en-CA'), // YYYY-MM-DD
      availablePopups: [],
    };
  },
  computed: {
    shownKey() {
      return `shownPopups_${this.platform}`;
    },
    lastVisitKey() {
      return `lastVisit_${this.platform}`;
    },

    currentPopup() {
      return this.availablePopups[this.currentPopupIndex];
    },
    isShown() {
      return this.currentPopup ? this.isPopupShownToday(this.currentPopup.id) : false;
    },
    locationId() {
      const loc = JSON.parse(localStorage.getItem('selectedLocation'));
      return loc && loc.id ? loc.id : 1;
    },
  },
  methods: {
    async getPopup() {
      try {
        const response = await api.get('commercials/popups/', {
          params: { type: this.platform, location: this.locationId },
        });
        this.popups = response.data;
        this.filterAvailablePopups();
      } catch (e) {
        console.log(e);
      }
    },
    isPopupShownToday(id) {
      const shownPopups = JSON.parse(localStorage.getItem(this.shownKey)) || {};
      return shownPopups[this.today] && shownPopups[this.today].includes(id);
    },
    markPopupAsShown(id) {
      const shownPopups = JSON.parse(localStorage.getItem(this.shownKey)) || {};
      if (!shownPopups[this.today]) {
        shownPopups[this.today] = [];
      }
      if (!shownPopups[this.today].includes(id)) {
        shownPopups[this.today].push(id);
        localStorage.setItem(this.shownKey, JSON.stringify(shownPopups));
      }
    },
    nextPopup() {
      // помечаем текущий как показанный при закрытии
      const cur = this.currentPopup;
      if (cur?.id) this.markPopupAsShown(cur.id);

      if (this.currentPopupIndex < this.availablePopups.length - 1) {
        this.currentPopupIndex++;
      } else {
        // попапы кончились — скрываем wrapper
        this.currentPopupIndex = this.availablePopups.length;
      }
    },
    resetPopups() {
      const lastVisit = localStorage.getItem(this.lastVisitKey);
      if (lastVisit !== this.today) {
        localStorage.setItem(this.lastVisitKey, this.today);
        localStorage.setItem(this.shownKey, JSON.stringify({}));
        this.currentPopupIndex = 0;
      }
    },
    filterAvailablePopups() {
      this.availablePopups = this.popups.filter(popup => !this.isPopupShownToday(popup.id));
    },
  },
  async mounted() {
    this.resetPopups();
    await this.getPopup();
  },
};
</script>
